import {Editor} from '@ckeditor/ckeditor5-core'
import {UploadAdapter, FileLoader} from '@ckeditor/ckeditor5-upload/src/filerepository'
import axios from 'axios'
import {getAuth} from '../../../../modules/auth'
import {GET_FILE, UPLOAD_FILE} from '../../../../modules/auth/core/_requests'

//const HOST = 'https://localhost:7152/File/api/uploadfile'

function uploadAdapter(loader: FileLoader): UploadAdapter {
  const {api_token}: any = getAuth()
  const formData = new FormData()
  return {
    upload: () => {
      return new Promise(async (resolve, reject) => {
        const file = await loader.file.then((f) => (f instanceof File ? f : null))
        if (file) {
          formData.append('file', file)
        }
        axios
          .post(UPLOAD_FILE, formData, {
            headers: {
              'Content-Type': 'multipart/form-data ',
              Authorization: 'Bearer ' + api_token,
            },
          })
          .then((response: any) => {
            let url: any = `${GET_FILE}${response.data.message[0].src}`
            resolve({
              default: response.data.result ? url : null,
            })
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    abort: () => {},
  }
}
function uploadPlugin(editor: any /*Editor*/) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
    return uploadAdapter(loader)
  }
}

export default uploadPlugin
